export enum ClinicalFormType {
    Form = 1,
    Tabular = 2
}
